import React, {useState} from 'react';
import './info-card.css'

const InfoCard = ({title="Title", text="Add Card Text"})=> {

    const formattedText = text?.split('\n')?.map((line, index) => {
        return (
            // <p key={index}>
            <div  key={index}>
                {line}
            </div>
        )
    }) 

    return (
        <div className="card-wrapper">
            <div className="card-title center">
                {title}
            </div>
            <div className="card-body parallax">
                <p className='card-text'>
                    {formattedText}
                </p>
            </div>
        </div>
    )
}

export default InfoCard;
